export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-50">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-fill text-background-50"></i>
              </span>
              <span className="font-heading text-lg font-bold">五一黑料网</span>
            </div>
            <p className="text-sm text-background-50/55 leading-relaxed">
              全网领先的黑料吃瓜内容聚合平台，每日追踪最新爆料、内幕事件和热点瓜，为百万吃瓜群众提供一站式的实时热点资讯。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="space-y-2.5">
              <a href="#index" className="block text-sm text-background-50/55 hover:text-primary-400 transition-colors cursor-pointer">内容导航</a>
              <a href="#cards" className="block text-sm text-background-50/55 hover:text-primary-400 transition-colors cursor-pointer">热瓜速递</a>
              <a href="#topics" className="block text-sm text-background-50/55 hover:text-primary-400 transition-colors cursor-pointer">热门话题</a>
              <a href="#ranking" className="block text-sm text-background-50/55 hover:text-primary-400 transition-colors cursor-pointer">热度飙升榜</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容板块</h4>
            <div className="space-y-2.5">
              <a href="#media" className="block text-sm text-background-50/55 hover:text-primary-400 transition-colors cursor-pointer">黑料视频合集</a>
              <a href="#carousel" className="block text-sm text-background-50/55 hover:text-primary-400 transition-colors cursor-pointer">焦点专题</a>
              <a href="#updates" className="block text-sm text-background-50/55 hover:text-primary-400 transition-colors cursor-pointer">最新动态</a>
              <a href="#faq" className="block text-sm text-background-50/55 hover:text-primary-400 transition-colors cursor-pointer">常见问答</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="space-y-2.5">
              <a href="#contact" className="block text-sm text-background-50/55 hover:text-primary-400 transition-colors cursor-pointer">投稿爆料</a>
              <a href="#about" className="block text-sm text-background-50/55 hover:text-primary-400 transition-colors cursor-pointer">关于我们</a>
              <a href="#app" className="block text-sm text-background-50/55 hover:text-primary-400 transition-colors cursor-pointer">移动端入口</a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-background-50/10">
          <div className="mb-6">
            <h4 className="text-sm font-semibold text-background-50/70 mb-3">合作伙伴</h4>
            <div className="flex flex-wrap gap-3">
              <span className="text-xs text-background-50/30 px-3 py-1.5 rounded-full border border-background-50/10">虚位以待</span>
              <span className="text-xs text-background-50/30 px-3 py-1.5 rounded-full border border-background-50/10">商务合作</span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/35">
              &copy; 2020-2026 五一黑料网 wuyiheiliao.com 版权所有
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-background-50/35">每日更新 · 全网热点 · 实时吃瓜</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}